import React from 'react';
import {useTranslation} from "react-i18next";
import {Text} from "../../../index";
import {TourStep1} from "../../../../image";
import './AiMeetingReviewStep.scss'

const AiMeetingReviewStep = () => {
    const {t} = useTranslation();

    return (
        <div className="step-video-hub">
            <img src={TourStep1} width={240} height={125}/>
            <Text size="f16" font="book" color="black">{t('ai_meeting_review_step_text_1')}
            </Text>
            <div style={{margin: '4px 0'}}/>
            <Text size="f16" font="book"  color="black">{t('ai_meeting_review_step_text_2')}
            </Text>
        </div>
    );
};

export default AiMeetingReviewStep;